import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'round',
    standalone: true
})
export class RoundPipe implements PipeTransform {

    transform(value: number, decimalPlaces: number): string {
        if (value) {
            return value.toFixed(decimalPlaces);
        } else {
            return ''
        }
    }

}
